/* istanbul ignore file */
import { lazy } from "react";

export const LazyResellerCertificateModal = lazy(() =>
  import(
    /* webpackChunkName: "reseller-certificate-modal" */ "@faire/retailer-visitor-shared/components/Modals/ResellerCertificateModal/__internal__/ResellerCertificateModal"
  ).then((m) => ({ default: m.ResellerCertificateModal }))
);
